export const GET_DATA_REQUEST = "GET_DATA_REQUEST";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_FAILURE = "GET_DATA_FAILURE";

export const ADD_DATA_REQUEST = "ADD_DATA_REQUEST";
export const ADD_DATA_SUCCESS = "ADD_DATA_SUCCESS";
export const ADD_DATA_FAILURE = "ADD_DATA_FAILURE";

export const GET_DATA_BY_ID_REQUEST = "GET_DATA_BY_ID_REQUEST";
export const GET_DATA_BY_ID_SUCCESS = "GET_DATA_BY_ID_SUCCESS";
export const GET_DATA_BY_ID_FAILURE = "GET_DATA_BY_ID_FAILURE";

export const UPDATE_DATA_REQUEST = "UPDATE_DATA_REQUEST";
export const UPDATE_DATA_SUCCESS = "UPDATE_DATA_SUCCESS";
export const UPDATE_DATA_FAILURE = "UPDATE_DATA_FAILURE";

export const UPDATE_DATA_ENTITY_PARAMS_SUCCESS = "UPDATE_DATA_ENTITY_PARAMS_SUCCESS";
export const UPDATE_DATA_ENTITY_PARAMS_FAILURE = "UPDATE_DATA_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_ALL_DATA_LOG_REQUEST = "GET_ALL_DATA_LOG_REQUEST";
export const GET_ALL_DATA_LOG_SUCCESS = "GET_ALL_DATA_LOG_SUCCESS";
export const GET_ALL_DATA_LOG_FAILURE = "GET_ALL_DATA_LOG_FAILURE";

export const RESTORE_DATA_LOG_REQUEST = "RESTORE_DATA_LOG_REQUEST";
export const RESTORE_DATA_LOG_SUCCESS = "RESTORE_DATA_LOG_SUCCESS";
export const RESTORE_DATA_LOG_FAILURE = "RESTORE_DATA_LOG_FAILURE";

export const DELETE_DATA_LOG_REQUEST = "DELETE_DATA_LOG_REQUEST";
export const DELETE_DATA_LOG_SUCCESS = "DELETE_DATA_LOG_SUCCESS";
export const DELETE_DATA_LOG_FAILURE = "DELETE_DATA_LOG_FAILURE";

export const GET_DATA_EXPORT_REQUEST = "GET_DATA_EXPORT_REQUEST";
export const GET_DATA_EXPORT_SUCCESS = "GET_DATA_EXPORT_SUCCESS";
export const GET_DATA_EXPORT_FAILURE = "GET_DATA_EXPORT_FAILURE";

export const DELETE_DATA_REQUEST = "DELETE_DATA_REQUEST";
export const DELETE_DATA_SUCCESS = "DELETE_DATA_SUCCESS";
export const DELETE_DATA_FAILURE = "DELETE_DATA_FAILURE";

export const GET_DROPDOWN_REQUEST = "GET_DROPDOWN_REQUEST";
export const GET_DROPDOWN_SUCCESS = "GET_DROPDOWN_SUCCESS";
export const GET_DROPDOWN_FAILURE = "GET_DROPDOWN_FAILURE";

export const SYNC_DATA_REQUEST = "SYNC_DATA_REQUEST";
export const SYNC_DATA_SUCCESS = "SYNC_DATA_SUCCESS";
export const SYNC_DATA_FAILURE = "SYNC_DATA_FAILURE";

export const CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_REQUEST = "CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_REQUEST";
export const CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_SUCCESS = "CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_SUCCESS";
export const CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_FAILURE = "CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_FAILURE";

export const CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_REQUEST = "CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_REQUEST";
export const CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_SUCCESS = "CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_SUCCESS";
export const CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_FAILURE = "CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_FAILURE";

export const GET_ALL_MANUFACTURER_CLIENTS_REQUEST = "GET_ALL_MANUFACTURER_CLIENTS_REQUEST";
export const GET_ALL_MANUFACTURER_CLIENTS_SUCCESS = "GET_ALL_MANUFACTURER_CLIENTS_SUCCESS";
export const GET_ALL_MANUFACTURER_CLIENTS_FAILURE = "GET_ALL_MANUFACTURER_CLIENTS_FAILURE";

export const GET_MANUFACTURER_CLIENT_DROPDOWN_REQUEST = "GET_MANUFACTURER_CLIENT_DROPDOWN_REQUEST";
export const GET_MANUFACTURER_CLIENT_DROPDOWN_SUCCESS = "GET_MANUFACTURER_CLIENT_DROPDOWN_SUCCESS";
export const GET_MANUFACTURER_CLIENT_DROPDOWN_FAILURE = "GET_MANUFACTURER_CLIENT_DROPDOWN_FAILURE";

export const dictionaryFields = {
    "assets.asset_name": "Asset Name",
    "assets.asset_description": "Asset Description",
    "assets.client_asset_condition__description": "Asset Condition Description",
    "assets.asset_ownership": "Asset Ownership",
    "assets.criticality": "Criticality",
    "assets.asset_tag": "Asset Tag",
    "assets.model_number": "Model Number",
    "assets.core_model_number": "Core Model Number",
    "assets.serial_number": "Serial Number",
    "assets.capacity": "Capacity",
    "assets.capacity_unit": "Capacity Unit",
    "assets.capacity_status": "Capacity Status",
    "assets.unit_cost": "Unit Cost",
    "assets.asset_barcode": "Asset Barcode",
    "assets.asset_client_id": "Asset Client ID",
    "assets.asset_cmms_id": "Asset CMMS ID",
    "assets.rtls_tag": "RTLS Tag",
    "assets.room_name": "Room Name",
    "assets.location": "Location",
    "assets.architectural_room_number": "Architectural Room Number",
    "assets.additional_room_description": "Additional Room Description",
    "assets.csp_unit": "CSP Unit",
    "assets.crv": "CRV",
    "assets.refrigerant": "Refrigerant",
    "assets.asset_note": "Asset Note",
    "assets.energy_use_type": "Energy Use Type",
    "assets.survey_id": "Asset Survey Id",
    "assets.survey_property_note": "Asset Survey Property Notes",
    "assets.installed_year_status": "Install Year Status",
    "assets.name_plate_status": "Name Plate Status",
    "assets.qa_notes": "Asset Survey QA/QC Notes",
    "assets.additional_qa_notes": "Asset Survey Additional QA/QC Notes",
    "assets.editor": "Asset Survey Editor",
    "assets.area_served": "Area Served",
    "assets.upstream_asset_barcode_number": "Upstream Asset Barcode Numbers",
    "assets.linked_asset_barcode_number": "Linked Asset Barcode Numbers",
    "assets.source_panel_name": "Source Panel Name",
    "assets.source_panel_barcode_number": "Source Panel Barcode Number",
    "assets.source_panel": "Source Panel Emergency/ Normal",
    "assets.skysite_hyperlink": "Skysite Hyperlink",
    "assets.quantity": "Quantity",
    "assets.parent_global_id": "Parent Global ID",
    "asset_additionals.boiler_type": "Boiler Type",
    "asset_additionals.boiler_burner_type": "Boiler Burner Type",
    "asset_additionals.boiler_btu_input": "Boiler BTU Input",
    "asset_additionals.boiler_btu_output": "Boiler BTU Output",
    "asset_additionals.boiler_hp": "Boiler HP",
    "asset_additionals.boiler_fuel": "Boiler Fuel",
    "asset_additionals.boiler_gas_pressure": "Boiler Gas Pressure",
    "asset_additionals.boiler_kw_input": "Boiler KW Input",
    "asset_additionals.boiler_power_burner_type": "Boiler Power Burner Type",
    "asset_additionals.boiler_burner_model": "Boiler Burner Model",
    "asset_additionals.boiler_burner_serial": "Boiler Burner Serial",
    "asset_additionals.unit_property_labeled": "Is Unit Properly Labeled",
    "asset_additionals.ahu_voltage": "Ahu Voltage",
    "asset_additionals.estimated_wire_run_length": "Estimated Wire Run Length",
    "asset_additionals.mca": "MCA",
    "asset_additionals.hot_gas_by_pass": "Hot Gas By-Pass",
    "asset_additionals.damper_type": "Damper Type",
    "asset_additionals.electric_heating": "Electric Heating",
    "asset_additionals.cooling_only": "Cooling Only",
    "asset_additionals.smoke_detector": "Smoke Detector",
    "asset_additionals.smoke_detector_return": "Smoke Detector-Return",
    "asset_additionals.vibration_isolation": "Vibration Isolation",
    "asset_additionals.curb_outside_dimension_length": "Existing Curb Outside Dimension Length",
    "asset_additionals.ducted_or_concentric_system": "Is this Ducted or Concentric System",
    "asset_additionals.boiler_pressure_type": "Boiler Operating Pressure Type",
    "asset_additionals.discharge": "Discharge",
    "asset_additionals.factory_mounted_disconnect": "Factory Mounted Disconnect",
    "asset_additionals.wire_type": "Wire Type",
    "asset_additionals.breaker_size": "Breaker Size",
    "asset_additionals.liquid_line": "Liquid Line",
    "asset_additionals.number_of_circuits": "Number Of Circuits",
    "asset_additionals.gas_heating": "Gas Heating",
    "asset_additionals.electric_heating_kw": "Electric Heating KW",
    "asset_additionals.controls": "Controls",
    "asset_additionals.smoke_detector_mounting": "Smoke Detector Mounting",
    "asset_additionals.curb": "Curb",
    "asset_additionals.burglar_bars": "Burglar Bars",
    "asset_additionals.curb_outside_dimension_width": "Existing Curb Outside Dimension Width",
    "asset_additionals.confirm_boiler_pressure": "Confirm Boiler Pressure",
    "asset_additionals.return": "Return",
    "asset_additionals.unit_voltage": "Unit Voltage",
    "asset_additionals.wire_size": "Wire Size",
    "asset_additionals.mocp": "MOCP",
    "asset_additionals.suction_line": "Suction Line",
    "asset_additionals.length_of_line": "Length of Line Run",
    "asset_additionals.gas_output_btu": "Gas Output BTU",
    "asset_additionals.pump_backup_heat_kw": "Heat Pump - Backup Heat KW",
    "asset_additionals.control_type": "Controls Type",
    "asset_additionals.smoke_detector_supply": "Smoke Detector-Supply",
    "asset_additionals.curb_description": "Curb Other Description",
    "asset_additionals.installed_on_adapter_curb": "Existing Unit Installed on an Adapter Curb?",
    "asset_additionals.allow_curb_adaptor": "Will Mall, Landlord, Municipality Allow a Curb Adapter?",
    "asset_additionals.unit_weight": "Unit Weight",
    "asset_additionals.codes_for_roof_lighting": "Any Special Codes Codes for Roof Lighting",
    "asset_additionals.code_or_safety_concerns": "Are there any Code or Safety Concerns",
    "asset_additionals.need_resealed": "Do Electrical/Piping Roof Penetrations Need To Be Resealed",
    "asset_additionals.split_system_line_sets_crimped": "Split System- Are Line Sets Crimped",
    "asset_additionals.line_connection_type": "Line Connection Type",
    "asset_additionals.codes_for_disconnects": "Any Special Codes for Disconnects",
    "asset_additionals.duct_work_attached_to_bottom_of_unit": "Current Duct Work Attached to Bottom of Unit",
    "asset_additionals.distance_from_salt_water_body": "Distance from Body Of Salt Water",
    "asset_additionals.split_system_line_sets_good_condition": "Split System - Are Line Sets Good Condition",
    "asset_additionals.split_system_line_sets_insulated": "Split System- Are Line Sets Insulated",
    "asset_additionals.codes_for_convenience_outlets": "Any Special Codes Codes for Convenience Outlets",
    "asset_additionals.aluminium_wire_used": "Was Aluminium Wire Used",
    "asset_additionals.recommend_coil_coating": "Recommend Coil Coating",
    "asset_additionals.split_system_line_sets_damaged": "Split System- Are Line Sets Damaged",
    "asset_additionals.split_system_line_sets_re_used": "Split System- Can Line Sets To Be Re-Used",
    "asset_auxiliaries.auxiliary_equipment_name": "Equipment Name",
    "asset_auxiliaries.auxiliary_model": "Model",
    "asset_auxiliaries.auxiliary_serial": "Serial",
    "asset_auxiliaries.auxiliary_date_manufactured": "Date Manufactured",
    "asset_auxiliaries.auxiliary_manufacturer": "Manufacturer",
    "asset_auxiliaries.auxiliary_condition": "Condition",
    "asset_auxiliaries.auxiliary_eul": "EUL",
    "asset_auxiliaries.auxiliary_crv": "CRV"
};
